import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';

const styles = theme => ({
    popup: {
        backgroundColor: '#fff',
		padding: '5px',
    },
});

const trStyle = {padding: '6px 4px 4px 4px'};

class MapPopup extends React.Component {
	generateData() {
		var i = 0;

		return this.props.data.map(function(entry) {
			if (entry.name && entry.value) {
				return (<tr key={i++}><td style={trStyle}>{entry.name}:</td><td style={trStyle}>{entry.value}{entry.aftertext ? entry.aftertext : ''}</td></tr>);

			} else if (entry.value) {
                return (<tr key={i++}><td colSpan="2" style={trStyle}>{entry.value}{entry.aftertext ? entry.aftertext : ''}</td></tr>);

			} else if (entry.childs) {
				var childs = entry.childs.map((childGroup) => {

					return (<div key={i++}><table key={i++} style={{width: '95%', borderTop: '1px solid #eee', margin: '1px'}}><tbody>{childGroup.map((entry) => {

						if (entry.name && entry.value) {
                            return (<tr key={i++}><td style={trStyle}>{entry.name}:</td><td style={trStyle}>{entry.value}{entry.aftertext ? entry.aftertext : ''}</td></tr>);

                        } else {
                            return (<tr key={i++}><td style={trStyle}></td><td style={trStyle}>{entry.value}{entry.aftertext ? entry.aftertext : ''}</td></tr>);
                        }
                    })}</tbody></table></div>);
				});

				return (<tr key={i++}><td colSpan="2"><div style={{maxHeight: '200px', overflowY: 'scroll'}}>{childs}</div></td></tr>);

			} else {
				return (<tr key={i++}><td style={trStyle}>{entry.value}{entry.aftertext ? entry.aftertext : ''}</td></tr>);
			}
		});
	}

	render() {
		const { classes } = this.props;

		var title = '';
		var style = {margin:'0 0 0 0'};

		if (this.props.title) {
			var title = (
				<div style={{padding: '0 5px'}}>
					<h4>{(this.props.icon ? this.props.icon : '')} {this.props.title}</h4>
				</div>
			);

			var style = {margin:'0 0 0 36px'};
		}

		return (
			<div>
				<Paper id={this.props.elementID} className={classes.popup} zdepth={1}>
					{title}
					<table style={style}><tbody>{this.generateData()}</tbody></table>
				</Paper>
			</div>
		);
	}
}

MapPopup.propTypes = {
	data: PropTypes.array,
	elementID: PropTypes.string,
	title: PropTypes.string
};

export default withStyles(styles)(MapPopup);



// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/components/popup/index.js